import styles from './style.module.css';
import api from '../../../api';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import 'moment/locale/ru';

const YearConference = () => {
    const [conference, setConference] = useState(null);

    useEffect(() => {
        let active = true;

        api.getConferences()
            .then((data) => {
                if (active) {
                    setConference(data.results?.[0] ?? null);
                }
            })
            .catch((err) => {
                console.log(err.message);
            });

        return () => {
            active = false;
        };
    }, []);

    if (!conference) {
        return null;
    }

    const hasDateRange = conference.end_date && conference.end_date !== conference.start_date;
    const sameYear = conference.start_date.slice(0, 4) === conference.end_date?.slice(0, 4);
    const sameMonth = conference.start_date.slice(0, 7) === conference.end_date?.slice(0, 7);
    const startDateFormat = hasDateRange
        ? (sameMonth ? 'DD' : sameYear ? 'DD MMMM' : 'DD MMMM YYYY[г.]')
        : 'DD MMMM YYYY[г.]';

    return (
        <Link to={`/conferences/${conference.id}/`}>
            <div className={styles.conference_section}>
                <div className={styles.title}>{conference.name}</div>
                <div className={styles.date}>
                    <Moment locale="ru" format={startDateFormat}>{conference.start_date}</Moment>
                    {hasDateRange && (
                        <>
                            {' - '}
                            <Moment locale="ru" format="DD MMMM YYYY[г.]">{conference.end_date}</Moment>
                        </>
                    )}
                </div>
                <div className={styles.btn_more__area}>
                    <Link to={`/conferences/${conference.id}/`}><div className={styles.btn_more}>Подробнее</div></Link>
                </div>
            </div>
        </Link>
    );
}

export default YearConference;
